/**
 *
 * @module adobeRegistration
 *
 */

import Services from './../../services/entry';

/**
 *
 * @class {AdobeRegistration}
 * @extends {SDK.Services.Identity.Adobe.AdobeRegistration}
 *
 */
export default class AdobeRegistration extends Services.Identity.Adobe.AdobeRegistration {}



// WEBPACK FOOTER //
// ./src/identity/adobe/adobeRegistration.js